import { Alert, Button, Card, PasswordInput, Stack, Text, TextInput, Title } from '@mantine/core'
import { useForm } from '@mantine/form'
import { zod4Resolver as zodResolver } from 'mantine-form-zod-resolver'
import { IconAlertCircle } from '@tabler/icons-react'
import { credenciales } from '@serkat/shared'
import { ErrorApi } from '../../api/cliente'
import { useIniciarSesion } from './useSesion'

export function LoginPagina() {
  const iniciar = useIniciarSesion()

  // El MISMO esquema Zod que valida en el backend.
  const form = useForm({
    initialValues: { correo: '', password: '' },
    validate: zodResolver(credenciales),
  })

  const mensajeError =
    iniciar.error instanceof ErrorApi ? iniciar.error.message : iniciar.error ? 'No se pudo conectar' : null

  return (
    <Stack align="center" justify="center" mih="100vh" bg="var(--mantine-color-body)">
      <Card shadow="sm" padding="xl" radius="md" withBorder w={400}>
        <Stack gap="md">
          <div>
            <Title order={3}>Seguimiento OC / OS</Title>
            <Text size="sm" c="dimmed">
              Ingrese con su cuenta de SERKAT
            </Text>
          </div>

          {mensajeError && (
            <Alert color="red" icon={<IconAlertCircle size={16} />} variant="light">
              {mensajeError}
            </Alert>
          )}

          <form onSubmit={form.onSubmit((v) => iniciar.mutate(v))}>
            <Stack gap="sm">
              <TextInput
                label="Correo"
                placeholder="usuario@serkat.pe"
                autoComplete="username"
                {...form.getInputProps('correo')}
              />
              <PasswordInput
                label="Contraseña"
                autoComplete="current-password"
                {...form.getInputProps('password')}
              />
              <Button type="submit" loading={iniciar.isPending} fullWidth mt="xs">
                Ingresar
              </Button>
            </Stack>
          </form>
        </Stack>
      </Card>
    </Stack>
  )
}
